import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import GlobalStyles from "./globalStyle";
import Routes from "./routes";
import { OpenProvider } from "./hooks/Open";
import { ToastContainer } from "react-toastify";
import "./components/UI/toast.css";
import { UserProvider } from "./hooks/UserContext";
import { Loader } from "./components/Loader";
import Header from "./components/HeaderMenuContent";
import { BrowserRouter } from "react-router-dom";

import store from "./store";
import { Provider } from "react-redux";
import { AppProvider } from "./contexts/AppContext";
import { SessionRecoveryProvider } from "./contexts/SessionRecoveryProvider";
import { FeatureFlagProvider } from "./contexts/FeatureFlagProvider";
import WhitelabelThemeProvider from "./WhitelabelThemeProvider";
import { useSearchVisibility } from "./hooks/useSearchVisibility";

function AppContent() {
  const showSearch = useSearchVisibility();
  return (
    <div className={showSearch ? "search-visible" : ""}>
      <Header />
      <Routes />
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Suspense fallback={<Loader />}>
    <BrowserRouter>
      <SessionRecoveryProvider>
        <Provider store={store}>
          <AppProvider>
            <FeatureFlagProvider>
              <WhitelabelThemeProvider>
                <UserProvider>
                  <OpenProvider>
                    <AppContent />
                  </OpenProvider>
                <ToastContainer
                  className="ll-toast-container"
                  toastClassName="ll-toast"
                  bodyClassName="ll-toast-body"
                  progressClassName="ll-toast-progress"
                  position="bottom-right"
                  limit={1}
                  pauseOnFocusLoss={false}
                  pauseOnHover={false}
                  hideProgressBar={false}
                  autoClose={1500}
                  closeOnClick
                  draggable
                  theme="light"
                />
                <GlobalStyles />
                </UserProvider>
              </WhitelabelThemeProvider>
            </FeatureFlagProvider>
          </AppProvider>
        </Provider>
      </SessionRecoveryProvider>
    </BrowserRouter>
  </Suspense>
);
